import baseRequest from '../baseRequest';
import AppConfig   from '../../app/config/AppConfig';
import {getLeadStatus} from '../../redux/actions';

class NewLeadRequest extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'New Lead Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch,payload) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.newLead, payload);
    }

    //Parse successful response
    //Response failure is handled in parent class: baseRequest
    onSuccess() {
        this.updateState();
    }

    //update redux store
    updateState() {
        this.dispatch(getLeadStatus(this.response.status));
    }
}
export default NewLeadRequest;